<template>
  <b-container fluid id="school-finance" class="mt-4">
    <b-row>
      <b-col>
        <div id="finance-form">
          <div id="alerts" ref="school-finance-alert">
            <b-alert
              :show="dismissCountDown"
              dismissible
              variant="success"
              @dismissed="dismissCountDown = 0"
              @dismiss-count-down="countDownChanged"
              >You have successfully added a finance record!</b-alert
            >
            <b-alert :show="formError" dismissible variant="warning">
              Something went wrong. Please refresh and try again, or contact the
              site admin.
            </b-alert>
          </div>
          <b-row id="headers">
            <b-col sm="2">Date</b-col>
            <b-col sm="1">Currency</b-col>
            <b-col sm="2">Fees</b-col>
            <b-col sm="2">
              Fees from
              <br />Parents
            </b-col>
            <b-col sm="1">
              Gov't
              <br />Salaries
            </b-col>
            <b-col sm="1">
              Gov't
              <br />Grants
            </b-col>
            <b-col sm="2">Other</b-col>
            <b-col sm="1"></b-col>
          </b-row>
          <b-row>
            <b-col sm="2">
              <b-form-input
                name="finance_date"
                type="date"
                id="date"
                v-model="dateForm"
                required
              ></b-form-input>
            </b-col>
            <b-col sm="1">
              <b-form-select
                name="currency"
                type="text"
                id="currency"
                v-model="currencyForm"
              >
                <option disabled value>Select a Currency</option>
                <option
                  v-for="currency in currencies"
                  :key="currency"
                  :value="currency"
                  >{{ currency }}</option
                >
              </b-form-select>
            </b-col>
            <b-col sm="2">
              <b-form-textarea
                :rows="1"
                type="text"
                name="fees"
                v-model="feesForm"
              ></b-form-textarea>
            </b-col>
            <b-col sm="2">
              <b-form-textarea
                :rows="1"
                type="text"
                name="fees-parents"
                v-model="feesParentsForm"
              ></b-form-textarea>
            </b-col>
            <b-col sm="1">
              <b-form-textarea
                :rows="1"
                type="text"
                name="gov-grants"
                v-model="govGrantsForm"
              ></b-form-textarea>
            </b-col>
            <b-col sm="1">
              <b-form-textarea
                :rows="1"
                type="text"
                name="gov-salaries"
                v-model="govSalariesForm"
              ></b-form-textarea>
            </b-col>
            <b-col sm="2">
              <b-form-textarea
                type="text"
                name="other"
                v-model="otherForm"
              ></b-form-textarea>
            </b-col>
            <b-col sm="1">
              <b-button
                v-if="isAdmin || isSRC"
                :variant="'primary'"
                @click="addOrUpdate"
              >
                {{ buttonTitle }}
              </b-button>
            </b-col>
          </b-row>
          <br />
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div id="finance-table">
          <b-table
            v-cloak
            responsive
            small
            :fields="fields"
            :items="financeTable"
            :striped="true"
            :bordered="true"
            :hover="true"
            stacked="md"
            :filter="filter"
            :current-page="currentPage"
            @filtered="onFiltered"
            :per-page="perPage"
            id="financing-table"
          >
            <template slot="cell(id)" slot-scope="row">
              <b-link v-if="isAdmin || isSRC" @click.stop="editSchoolFinancing(row)"
                >Edit</b-link
              >
            </template>
            <template slot="cell(delete)" slot-scope="row">
              <b-link
                class="delete"
                v-if="isAdmin || isSRC"
                @click.stop="deleteSchoolFinancing(row.item.id)"
                >DELETE</b-link
              >
            </template>
          </b-table>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import SchoolService from "../services/SchoolService";
import { flash } from "../mixins/flashes";
import { scrollTo } from "../mixins/scrollTo";

export default {
  name: "SchoolFinance",
  mixins: [flash, scrollTo],
  data() {
    return {
      dateForm: null,
      currencyForm: "",
      feesForm: "",
      feesParentsForm: "",
      govSalariesForm: "",
      govGrantsForm: "",
      otherForm: "",
      id: "",
      disabled: false,
      required: false,
      changeTitle: false,
      currencies: ["MWK", "NAD", "UGX", "USD", "ZAR", "ZMK"],
      fields: [
        { key: "finance_date", label: "Date", sortable: true },
        { key: "currency", label: "Currency", sortable: true },
        { key: "fees", label: "Fees", sortable: true },
        { key: "fees_parents", label: "Parents Fees", sortable: true },
        { key: "gov_salaries", label: "Gov't Salaries", sortable: true },
        { key: "gov_grants", label: "Gov't Grants", sortable: true },
        { key: "other", label: "Other", sortable: true },
        { key: "id", label: "Edit" },
        { key: "delete", label: "Delete" },
      ],
      filter: "",
      totalRows: this.rows,
      currentPage: 1,
      perPage: 20,
      formError: false,
    };
  },
  computed: {
    ...mapGetters({
      isAdmin: "auth/isAdmin",
       isSRC: "auth/isSRC",
    }),
    buttonTitle() {
      return this.changeTitle ? "Edit" : "Submit";
    },
    financeTable: {
      get() {
        return this.$store.state.schools.financings;
      },
    },
    rows() {
      if (this.financeTable) {
        return this.financeTable.length;
      }
    },
  },
  methods: {
    ...mapActions({
      GET_FINANCINGS: "schools/GET_SCHOOL_FINANCINGS",
    }),
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async addSchoolFinancing() {
      if (this.dateForm === null || this.feesForm === null) {
        this.formError = true;
        this.flashError();
        return;
      }
      await SchoolService.addSchoolFinancing({
        date: this.dateForm,
        school_uuid: this.$route.params.id,
        currency: this.currencyForm,
        fees: this.feesForm,
        fees_parents: this.feesParentsForm,
        gov_salaries: this.govSalariesForm,
        gov_grants: this.govGrantForm,

        other: this.otherForm,
      });
      await this.scrollTo("school-finance-alert");
      await this.flashSuccess();
      this.clearForm();
      this.formError = false;
      this.changeTitle = false;
      await this.GET_FINANCINGS();
    },
    async updateSchoolFinancing() {
      if (this.dateForm === null || this.feesForm === null) {
        this.formError = true;
        this.flashError();
        return;
      }
      await SchoolService.updateSchoolFinancing({
        id: this.id,
        date: this.dateForm,
        school_id: parseInt(this.$route.params.id),
        currency: this.currencyForm,
        fees: this.feesForm,
        fees_parents: this.feesParentsForm,
        gov_salaries: this.govSalariesForm,
        gov_grants: this.govGrantForm,

        other: this.otherForm,
      });
      await this.scrollTo("school-finance-alert");
      await this.flashSuccess();
      this.clearForm();
      this.formError = false;
      this.changeTitle = false;
      await this.GET_FINANCINGS();
    },
    async addOrUpdate() {
      if (this.buttonTitle === "Edit") {
        this.updateSchoolFinancing();
      } else {
        this.addSchoolFinancing();
      }
    },
    async deleteSchoolFinancing(params) {
      const confirmDelete = confirm(
        "Are you sure you want to delete this finance record?"
      );
      if (confirmDelete) {
        await SchoolService.deleteSchoolFinancing(params);
        await this.GET_FINANCINGS();
      }
    },
    clearForm() {
      this.dateForm = null;
      this.currencyForm = "";
      this.feesForm = "";
      this.feesParentsForm = "";
      this.govSalariesForm = "";
      this.govGrantForm = "";
      this.otherForm = "";
      this.id = "";
    },
    editSchoolFinancing(row) {
      this.changeTitle = true;
      this.dateForm = row.item.finance_date;
      this.currencyForm = row.item.currency;
      this.feesForm = row.item.fees;
      this.feesParentsForm = row.item.fees_parents;
      this.govSalariesForm = row.item.gov_salaries;
      this.govGrantForm = row.item.gov_grants;
      this.adHocForm = row.item.ad_hoc_funding;
      this.otherForm = row.item.other;
      this.id = row.item.id;
      this.financeTable.splice(row.index, 1);
    },
  },
  created() {
    this.GET_FINANCINGS();
  },
};
</script>

<style scoped>
#headers,
#date {
  text-align: left;
}
#edit_icon {
  float: left;
}
#delete_icon {
  width: 20%;
}
h1,
#add_icon {
  display: inline;
}
#add_icon {
  width: 3%;
  opacity: 80%;
}
table th,
table tr {
  text-align: center;
  word-break: break-all;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
table thead {
  background: #bf9660;
}
td {
  width: 100px;
  text-align: center;
}
table tr td {
  padding: 10px;
}
table tr:nth-child(odd) {
  background: #f2f2f2;
}
table tr:nth-child(1) {
  background: #bf9660;
  color: #fff;
}
#headers {
  text-align: center;
}
.col-sm-2,
.col-sm-1 {
  padding: 0 5px 0 5px;
}
</style>
